<template lang="pug">
.appTutorialParagraphComponent
  .paragraph(:class="paragraphClasses")
    .icon(v-if="item.pointer")
      ui-svg-icon(
        :name="iconName"
        original-colors
      )
    .text(
      v-html="item.text"
      :class="textClasses"
    )
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'AppTutorialParagraph',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const iconName = computed(() => (!props.item.hover ? 'pointer' : 'pointer-full'))
    const textClasses = computed(() => ({
      _hover: props.item.hover && props.item.pointer
    }))
    const paragraphClasses = computed(() => ({ _pointer: props.item.pointer }))

    return {
      iconName,
      textClasses,
      paragraphClasses
    }
  }
}
</script>

<style lang="sass" scoped>
.appTutorialParagraphComponent
  &:first-child
    .paragraph
      margin-top: 0
  .paragraph
    @include font('t16-regular')
    margin-top: 4*$u
    max-width: 200*$u
    &._pointer
      margin-top: 0
    .text
      display: inline
      &._hover
        background: $cHtGreen
        box-shadow: 0 -4px 0 $cHtGreen, 0 4px 0 $cHtGreen
    .icon
      display: inline-block
      width: 8*$u
      height: 10*$u
      position: relative
      top: 3*$u
      margin-right: 3*$u
</style>
